import { get, post, put, del } from '@api/request';

export const fetchCodefileConfig = async (
  { queueService },
  authenticationToken,
) => {
  const url = `${queueService}/queue/codefileconfig`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchDetailCodefiles = async (
  { queueService },
  authenticationToken,
  { year, type, name, pageSize, page, sortDirection, sortField, filterModel },
) => {
  let url = `${queueService}/queue/codefiles?type=${type}&name=${name}&pageSize=${pageSize}&page=${page}`;
  if (year || year === 0) {
    url += `&year=${year}`;
  }
  if (sortField) {
    url += `&sortDirection=${sortDirection}&sortField=${sortField}`;
  }
  if (filterModel && Object.keys(filterModel).length >= 0) {
    Object.keys(filterModel).forEach(filter => {
      url += `&searchField=${filter}&searchText=${filterModel[filter].value}`;
    });
  }

  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchSummaryCodefiles = async (
  { queueService },
  authenticationToken,
  { year, type, name, page, pageSize, sortField, sortDirection, filterModel },
) => {
  // prettier-ignore
  let url = `${queueService}/queue/codefilesummary?type=${type}&name=${name}&pageSize=${pageSize}&page=${page}`;
  if (sortField) {
    url += `&sortDirection=${sortDirection}&sortField=${sortField}`;
  }
  if (year || year === 0) {
    url += `&year=${year}`;
  }
  if (filterModel && Object.keys(filterModel).length >= 0) {
    Object.keys(filterModel).forEach(filter => {
      url += `&searchField=${filter}&searchText=${filterModel[filter].value}`;
    });
  }

  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertCodefile = async (
  { queueService },
  authenticationToken,
  { payload },
) => {
  const url = `${queueService}/queue/codefiles`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateCodefile = async (
  { queueService },
  authenticationToken,
  { payload },
) => {
  let url = `${queueService}/queue/codefile/${payload.codeFileYear}`;

  if (payload.codeFileType) {
    url += `/${payload.codeFileType}`;
  }
  if (payload.codeFileName) {
    url += `/${payload.codeFileName}`;
  }
  if (payload.codeName) {
    url += `/${payload.codeName}`;
  }

  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deleteCodefile = async (
  { queueService },
  authenticationToken,
  { payload },
) => {
  // prettier-ignore
  let url = `${queueService}/queue/codefile/${payload.codeFileYear}/${payload.codeFileType}/${payload.codeFileName}/${encodeURI(payload.codeName)}`;

  const { body } = await del(authenticationToken, url);
  return body;
};
